const strings = {
  writeClassificationToasts: {
    successUpsert: 'Call completed',
    noTenantAccess:
      'Call Completed - You do not have permission to classify calls for this account',
  },
} as const;

export default strings;
